import * as React from 'react';
import theme from './theme.module.scss';
import useSessionManager from '../../../../../session/hooks/useSessionManager';
import {observer} from "mobx-react";
import useUserManager from '../../../../../../common/hooks/useUserManager';
import {Avatar, Icon} from '@vidazoo/ui-kit';
import {useCallback} from 'react';
import {useMainMenuContext} from "../../contexts/MainMenuContext";

const GROUP = 'USER_MENU';

function UserMenu() {
    const user = useUserManager();
    const sessionManager = useSessionManager();
    const {selectedGroup, setSelectedGroup} = useMainMenuContext();
    const onLogoutClick = useCallback(() => sessionManager.logout(), []);
    const open = selectedGroup === GROUP;

    const onProfileClick = () => {
        // The legacy app closes the menu here; its profile modal is no longer mounted.
        setSelectedGroup(null);
    };

    return (
        <div onMouseEnter={() => setSelectedGroup(GROUP)} onMouseLeave={() => setSelectedGroup(null)}
             className={theme.userMenu}
             onKeyDown={event => {if (event.key === 'Escape') setSelectedGroup(null);}}>
            <button className={theme.trigger} type="button" aria-label="User menu" aria-expanded={open}
                onClick={() => setSelectedGroup(GROUP)}>
                <Avatar small dark imageUrl={user.avatar}/>
            </button>
            {open ? (
                <div className={theme.drawer} role="region" aria-label="Account menu">
                    <div className={theme.banner}>
                        <Avatar imageUrl={user.avatar}/>
                        <div className={theme.info}>
                            <div className={theme.name}>{sessionManager.fullName}</div>
                            <div className={theme.email}>{sessionManager.email}</div>
                        </div>
                    </div>
                    <button className={theme.action} type="button" onClick={onProfileClick}>
                        <Icon iconName="icon-settings" size={2}/>
                        My Profile
                    </button>
                    <button className={theme.action} type="button" onClick={onLogoutClick}>
                        <Icon iconName="icon-sign-out" size={2}/>
                        Sign Out
                    </button>
                    <div className={theme.links}>
                        <a rel="noreferrer"
                           href="https://vidazoo.gitbook.io/vidazoo-legal/terms-and-conditions" target="_blank">Terms
                            & Conditions</a>
                        <span className={theme.separator} aria-hidden="true">|</span>
                        <a rel="noreferrer"
                           href="https://vidazoo.gitbook.io/vidazoo-legal/privacy-policy" target="_blank">Privacy
                            Policy</a>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default observer(UserMenu);
